<template>
  <div>
    <div v-if="conditional.if">
      <conditional-group
        :conditionalGroup="conditional.if"
        :entityName="entityName"
        :optionAttributeEntityName="optionAttributeEntityName"
        @remove="$set(conditional, 'if', undefined)"
        @update="conditional => $emit('update', conditional)"
        v-if="conditional.if.type === 'conditionalGroup'"
      ></conditional-group>
      <conditional
        :entityName="entityName"
        :conditional="conditional.if"
        :optionAttributeEntityName="optionAttributeEntityName"
        @remove="$set(conditional, 'if', undefined)"
        @update="update"
        v-if="conditional.if.type === 'conditional'"
      ></conditional>
    </div>

    <div class="d-flex mt-4" v-if="!conditional.if">
      <v-btn @click="addConditional" color="primary" outlined small
        >Add Check</v-btn
      >

      <v-btn
        class="ml-2"
        @click="addConditionalGroup"
        color="primary"
        outlined
        small
        >Add Check Group</v-btn
      >
    </div>
  </div>
</template>

<script>
import Conditional from "./Conditional";
import ConditionalGroup from "./ConditionalGroup";

export default {
  components: {
    Conditional,
    ConditionalGroup,
  },
  methods: {
    addConditional() {
      this.$set(this.conditional, "if", { type: "conditional" });
      this.$emit("update", this.conditional);
    },
    addConditionalGroup() {
      this.$set(this.conditional, "if", { type: "conditionalGroup", list: [] });
      this.$emit("update", this.conditional);
    },
    update(conditionalIf) {
      this.$set(this.conditional, "if", conditionalIf);
      this.$emit("update", this.conditional);
    },
  },
  props: {
    conditional: {
      required: true,
      type: Object,
    },
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
    entityName: {
      required: true,
    },
    mode: {
      default: "create",
      type: String,
      validator: function (value) {
        return ["create", "update"].includes(value);
      },
    },
  },
};
</script>
